var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    'lbz-fab',
    _vm.type && ("lbz-fab--" + _vm.type),
    _vm.background && ("lbz-fab--" + _vm.background),
    _vm.inactive && 'lbz-is-inactive'
  ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.$slots.default)?_c('lbz-icon',{staticClass:"lbz-fab__icon"},[_vm._t("default")],2):_vm._e(),(_vm.type === 'extended')?_c('span',{staticClass:"lbz-fab__label",domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e(),_c('lbz-state',_vm._b({},'lbz-state',_vm.cgetStateAttrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }